module.exports = __webpack_public_path__ + "img/Formula.c0150f95.png";